import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Tooltip, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

import { exportActions } from '../../redux/actions';
import { downloadExportCsv } from '../../utils/csvExport';

const MSG_KEY = 'bc-export';

/**
 * Exports the given business case (total + its scenarios) to "<BC name>.csv",
 * with the business case's allocations applied unless includeAllocations is false.
 */
const ExportBusinessCaseButton = ({ businessCase, includeAllocations = true, disabled = false }) => {
    const dispatch = useDispatch();
    const organization = useSelector((state) => state.organization.organization);
    const [exporting, setExporting] = useState(false);

    const handleExport = async () => {
        if (!businessCase || exporting) return;

        setExporting(true);
        message.loading({ content: `Exporting "${businessCase.name}"...`, key: MSG_KEY, duration: 0 });

        try {
            const data = await dispatch(
                exportActions.exportBusinessCase(businessCase.business_case_id, { includeAllocations })
            );
            downloadExportCsv(data, organization, businessCase.name || `Business case ${businessCase.business_case_id}`);
            message.success({ content: `Exported "${businessCase.name}".`, key: MSG_KEY, duration: 2 });
        } catch (err) {
            message.error({ content: err?.message || 'Export failed.', key: MSG_KEY, duration: 5 });
        } finally {
            setExporting(false);
        }
    };

    return (
        <Tooltip title={businessCase ? 'Export business case and its scenarios (CSV)' : 'Select a business case first'}>
            <span>
                <Button
                    shape="circle"
                    icon={<DownloadOutlined />}
                    onClick={handleExport}
                    disabled={!businessCase || disabled}
                    loading={exporting}
                    aria-label="Export business case"
                />
            </span>
        </Tooltip>
    );
};

export default ExportBusinessCaseButton;
